export default __webpack_public_path__ + "assets/images/e7a91eec8787222c2613bb7400d190a7.png";